export enum AnalyticsAccountType {
  EMAIL = 'email',
  PHONE = 'phone',
}
